import { Tag } from 'antd'
import moment from 'moment'
import { colours } from '@qflow/theme'
import { getCertStatus } from 'admin/lib/Certificates/CertificateExpiry'

export function CertificateTag({ id, cert, ...props }) {
  return (
    <Tag
      key={id}
      title={cert?.companyName}
      {...props}
      style={
        props.onClose && {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }
      }
    >
      <div>
        {cert
          ? `${cert.certificationScheme} (${cert.certificateNumber})`
          : 'Unknown Certificate'}
        {cert && cert.expirationDate && (
          <>
            <br />
            <span
              style={{
                color: cert ? getCertStatus(cert).color : colours.RED
              }}
            >
              Exp: {moment(cert.expirationDate).local().format('DD/MM/YYYY')}
            </span>
          </>
        )}
      </div>
    </Tag>
  )
}
